export enum DeliveryOrderEventStatus {
    COMPLETE = 'complete',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}
